<template>
    <div class="dhf-accordion-group">
        <h3 class="dhf-accordion-group__control">
            <button
                :id="`dhf-accordion-group__control-button-${props.id}`"
                :aria-controls="`dhf-accordion-group__section-${props.id}`"
                :aria-expanded="isExpanded"
                class="dhf-accordion-group__control-button"
                type="button"
                @click="toggleAccordion()"
            >
                <slot name="title" />
                <span class="dhf-accordion-group__icon" :class="{ 'dhf-accordion-group__icon--active': isExpanded }">
                    <DhfIcon name="minus" />
                    <DhfIcon name="minus" />
                </span>
            </button>
        </h3>

        <Transition name="expand">
            <div
                v-show="isExpanded"
                :id="`dhf-accordion-group__section-${props.id}`"
                ref="bodyElement"
                role="region"
                :style="{ 'max-height': maxHeight + 'px' }"
                :aria-labelledby="`dhf-accordion-group__control-button-${props.id}`"
                class="dhf-accordion-group__section"
            >
                <slot name="content" />
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, ref } from 'vue';
import DhfIcon from '@/components/dhf-icon/dhf-icon.vue';

const isExpanded = ref(false);
const bodyElement = ref<HTMLElement>();
const maxHeight = ref<number>(0);
let animationTimeout: any = null;

const props = defineProps<{
    id?: string;
}>();

function toggleAccordion() {
    const accordionElement = bodyElement.value;

    if (!accordionElement) {
        return;
    }

    isExpanded.value = !isExpanded.value;

    // wait until styling from transition component was done
    animationTimeout = setTimeout(() => {
        maxHeight.value = isExpanded.value ? accordionElement.scrollHeight : 0;
    }, 1);
}

onBeforeUnmount(() => {
    clearTimeout(animationTimeout);
});
</script>

<style lang="scss">
@import './dhf-accordion.scss';
</style>
